export const temporaryNews = [{
    projectId: 0, // 项目编号
    outsideMsg: '当前项目的编号是：149,这是一条首页消息的通知示例', // 首页消息
    insideMsg: '当前项目的编号是：149是内介专属通道的示例消息', // 内介列表消息
  }];